export const SET_FACET_CONSTANTS = 'Set facet constants';
export const REPORT_ERROR = 'Report error';
export const CLEAR_ERROR = 'Clear error';
export const SET_SEARCH_TERM = 'Set search term';
